import { frontendURL } from 'dashboard/helper/URLHelper';
import QualificaAIPage from './QualificaAIPage.vue';
import LeadCapturePublicPage from './LeadCapturePublicPage.vue';

export const publicRoutes = [
  {
    path: frontendURL('captacao/:slug'),
    name: 'qualifica_ai_public_capture',
    meta: {
      public: true,
    },
    component: LeadCapturePublicPage,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/qualifica-ai'),
    name: 'qualifica_ai',
    meta: {
      permissions: ['administrator'],
      superAdminOnly: true,
    },
    component: QualificaAIPage,
  },
];
